// extracted by mini-css-extract-plugin
export default {"timeRow":"WdvG6_xAIB7Z2WgY3mwr","time":"lG6zVHBdBEHszfv0Wc8q","scheduleBox":"YL2gvB2b_Cjf_YcGog_j"};